export default "__VITE_ASSET__02eb94b5__"